// Per-tenant customer identity roster (C.2b-identity). Tenant-scoped by
// slug only (no account in the path). Members are addressed by id;
// username is editable. See backend api/v1/tenant_identity.py.

import { request, type ApiResponse } from "../client";
import type {
  IdentityMemberCreateIn,
  IdentityMemberOut,
  IdentityMemberUpdateIn,
} from "../types/identityMember";

const base = (tenantSlug: string) =>
  `/api/v1/tenants/${encodeURIComponent(tenantSlug)}/identity-members`;

export const identityMembers = {
  list: (tenantSlug: string): Promise<ApiResponse<IdentityMemberOut[]>> =>
    request<IdentityMemberOut[]>("GET", base(tenantSlug)),

  create: (
    tenantSlug: string,
    body: IdentityMemberCreateIn,
  ): Promise<ApiResponse<IdentityMemberOut>> =>
    request<IdentityMemberOut>("POST", base(tenantSlug), body),

  update: (
    tenantSlug: string,
    memberId: string,
    body: IdentityMemberUpdateIn,
  ): Promise<ApiResponse<IdentityMemberOut>> =>
    request<IdentityMemberOut>(
      "PUT",
      `${base(tenantSlug)}/${encodeURIComponent(memberId)}`,
      body,
    ),

  remove: (tenantSlug: string, memberId: string): Promise<ApiResponse<void>> =>
    request<void>(
      "DELETE",
      `${base(tenantSlug)}/${encodeURIComponent(memberId)}`,
    ),
};
